// Get dates for the past week in user's local timezone
export const getPastWeekDates = () => {
    const dates = [];
    for (let i = 6; i >= 0; i--) {
        const date = new Date();
        date.setDate(date.getDate() - i);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        dates.push(`${month}/${day}`);
    }
    return dates;
};

// Format timestamp to MM/DD in user's local timezone
export const formatDate = (timestamp) => {
    // Convert UTC timestamp to local date
    const year = timestamp.substring(0, 4);
    const month = timestamp.substring(4, 6);
    const day = timestamp.substring(6, 8);
    const hour = timestamp.substring(8, 10) || '00';
    const minute = timestamp.substring(10, 12) || '00';
    const second = timestamp.substring(12, 14) || '00';

    // Create date in UTC
    const utcDate = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
    
    // Convert to local date
    const localDate = new Date(utcDate);
    const localMonth = String(localDate.getMonth() + 1).padStart(2, '0');
    const localDay = String(localDate.getDate()).padStart(2, '0');
    
    return `${localMonth}/${localDay}`;
};

// Check if a date is within the past week in user's local timezone
export const isWithinPastWeek = (timestamp) => {
    // Convert UTC timestamp to local date
    const year = timestamp.substring(0, 4);
    const month = timestamp.substring(4, 6);
    const day = timestamp.substring(6, 8);
    const hour = timestamp.substring(8, 10) || '00';
    const minute = timestamp.substring(10, 12) || '00';
    const second = timestamp.substring(12, 14) || '00';

    // Create date in UTC
    const utcDate = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
    
    // Convert to local date
    const callDate = new Date(utcDate);
    callDate.setHours(0, 0, 0, 0);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const diffTime = today - callDate;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    return diffDays >= 0 && diffDays <= 6;
};

// Format date for charts (MM/DD format with timezone conversion)
export const formatChartDate = (timestamp) => {
  // Parse the timestamp components
  const year = timestamp.substring(0, 4);
  const month = timestamp.substring(4, 6);
  const day = timestamp.substring(6, 8);
  const hour = timestamp.substring(8, 10) || '00';
  const minute = timestamp.substring(10, 12) || '00';
  const second = timestamp.substring(12, 14) || '00';

  // Create date in UTC
  const utcDate = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
  
  // Convert to local date
  const localDate = new Date(utcDate);
  
  // Format as MM/DD
  const localMonth = String(localDate.getMonth() + 1).padStart(2, '0');
  const localDay = String(localDate.getDate()).padStart(2, '0');

  return `${localMonth}/${localDay}`;
}

export const parseCustomTimestamp = (timestamp) => {
    if (!timestamp || timestamp.length < 15) return null; // Guard against invalid format
    try {
        const year = timestamp.substring(0, 4);
        const month = timestamp.substring(4, 6);
        const day = timestamp.substring(6, 8);
        const hour = timestamp.substring(9, 11);
        const minute = timestamp.substring(11, 13);
        const second = timestamp.substring(13, 15);
        
        // Creates a Date object from the components, assuming the timestamp is in UTC.
        // This is more reliable across browsers than new Date('YYYY-MM-DDTHH:mm:ssZ')
        return new Date(Date.UTC(year, month - 1, day, hour, minute, second));
    } catch (e) {
        console.error("Failed to parse custom timestamp:", timestamp, e);
        return null;
    }
};